document.addEventListener("DOMContentLoaded", function () {
  // functionality to prevent customer from entering more items than are in stock

  const quantityTooltip = document.querySelector(".tooltip_quantity");
  const quantityTooltipCaret = document.querySelector(
    ".caret-reversed-quantity"
  );
  const heighText = document.querySelector(".h-text-position");
  const widthText = document.querySelector(".w-text-position");

  // get cal input
  const calc = document.getElementsByClassName("calc-prop");
  const tooltipHeight = document.querySelector(".tooltip_height");
  const tooltipWidth = document.querySelector(".tooltip_width");
  const caratHeight = document.querySelector(".caret-reversed-height");
  const caratWidth = document.querySelector(".caret-reversed-width");

  const maxH = document.querySelector("#max-height");
  const minH = document.querySelector("#min-height");
  const minW = document.querySelector("#min-width");
  const maxW = document.querySelector("#max-width");
  const maxQuantity = document.querySelector("#quantity-div");
  let widthInput;
  let heightInput;
  let handlersInitialized = false;
  let cartButtonValidationInitialized = false;

  function getQuantityInput() {
    if(maxQuantity){
      const maxValue = maxQuantity.dataset.quantity; 
      calc[2].setAttribute('max', maxValue);
    }

  

    // calc[2] &&
    //   calc[2].addEventListener("input", function () {
    //     // Set the max attribute
    //     console.log("calc2" , calc[2])
    //     if (parseInt(this.value) > parseInt(maxQuantity.dataset.quantity)) {
    //       quantityTooltip.style.display = "flex";
    //       quantityTooltipCaret.style.display = "inline-block";
    //       if (window.matchMedia("(min-width: 750px)").matches) {
    //         // heighText.style.left = "-30px";
    //         // widthText.style.left = "165px";
    //       }
    //       if (window.matchMedia("(max-width: 375px)").matches) {
    //         // heighText.style.left = "275px";
    //         // widthText.style.left = "249px";
    //       }
    //       // heighText.style.left = "-30px";
    //       // widthText.style.left = "165px";
    //     } else {
    //       quantityTooltip.style.display = "none";
    //       quantityTooltipCaret.style.display = "none";
    //       if (window.matchMedia("(min-width: 750px)").matches) {
    //         // heighText.style.left = "-90px";
    //         // widthText.style.left = "111px";
    //       }
    //       if (window.matchMedia("(max-width: 375px)").matches) {
    //         // heighText.style.left = "254px";
    //         // widthText.style.left = "229px";
    //       }
    //     }
    //   });
  }

  function getHeightInput() {
    for(let i = 0; i < calc.length; i++){
      let calcName = (calc[i].dataset.calcname || "").replace(/\s+/g, "");
      if(calcName === "Height" || calcName === "diamater" || calcName === "length"){
        calc[i].addEventListener("input", function () {
          const diameter =   calc[i].dataset.calcname;
          
          if (parseInt(this.value) > parseInt(maxH.innerHTML.replace(/,/g, ""))) {
            tooltipHeight.innerHTML = `最大値${maxH.innerHTML}です`;
        
            tooltipHeight.style.visibility = "visible";
            caratHeight.style.visibility = "visible";
            calc[i].setAttribute("style", "border: 2px solid #fe6847 !important");
            calc[i].style.boxSizing = "border-box !important";
          } else if (parseInt(this.value) < parseInt(minH.innerHTML.replace(/,/g, "")) ) {

            tooltipHeight.innerHTML = `最小値${minH.innerHTML} です`;
           
            tooltipHeight.style.visibility = "visible";
            caratHeight.style.visibility = "visible";
            calc[i].setAttribute("style", "border: 2px solid #fe6847 !important");
            calc[i].style.boxSizing = "border-box !important";
          } else {
            tooltipHeight.style.visibility = "hidden";
            caratHeight.style.visibility = "hidden";
            calc[i].setAttribute("style", "border: 2px solid #004ba0 !important");
            calc[i].style.boxSizing = "border-box !important";
          }
          heightInput = this.value;
        });
      }
    }
  }

  function getWidthInput() {
    for(let i = 0; i < calc.length; i++){
      let calcName = (calc[i].dataset.calcname || "").replace(/\s+/g, "");
      if(calcName === "Width" || calcName === "width" || calcName === "Length"){
        calc[i].addEventListener("input", function () {
    
        const length = calc[i].dataset.calcname;
        if (parseInt(this.value) < parseInt(minW.innerHTML.replace(/,/g, ""))) {

          tooltipWidth.innerHTML = `最小値${minW.innerHTML}です`;           
          
          tooltipWidth.style.visibility = "visible";
          caratWidth.style.visibility = "visible";
          calc[i].setAttribute("style", "border: 3px solid #fe6847 !important");
          calc[i].style.boxSizing = "border-box";
        } else if ( parseInt(this.value) > parseInt(maxW.innerHTML.replace(/,/g, ""))) {

          tooltipWidth.innerHTML = `最大値${maxW.innerHTML}です`;
        
          tooltipWidth.style.visibility = "visible";
          caratWidth.style.visibility = "visible";
          calc[1].setAttribute("style", "border: 3px solid #fe6847 !important");
          calc[1].style.boxSizing = "border-box";
        } else {
          tooltipWidth.style.visibility = "hidden";
          caratWidth.style.visibility = "hidden";
          calc[1].setAttribute("style", "border: 3px solid #004ba0 !important");
          calc[1].style.boxSizing = "border-box";
        }
        widthInput = this.value;
      });
      }
    }
  }

  function setBorder() {
    calc[0] &&
      calc[0].addEventListener("focus", function () {
        calc[0].setAttribute("style", "border: none");
      });
    calc[0] &&
      calc[0].addEventListener("blur", function () {
        calc[0].setAttribute("style", "border: none");
      });

    calc[1] &&
      calc[1].addEventListener("focus", function () {
        calc[1].setAttribute("style", "border: none");
        // calc[1].parentNode.style.top = "-49px";
      });
    calc[1] &&
      calc[1].addEventListener("blur", function () {
        calc[1].setAttribute("style", "border: none");
        // calc[1].parentNode.style.top = "-49px";
      });
  }

  //round sock filters values
  function customRoundToTen(value) {
    const lastDigit = value % 10;
    if (lastDigit < 5) {
      return value - lastDigit;
    } else {
      return value + (10 - lastDigit);
    }
  }

  function customRoundToHundred(value) {
    const lastTwoDigits = value % 100;
    if (lastTwoDigits === 0) {
      return value;
    } else if (lastTwoDigits <= 50) {
      return value - lastTwoDigits;
    } else {
      return value + (100 - lastTwoDigits);
    }
  }

  // 値補正時に計算系イベントと外部計算関数を呼び出すヘルパー
  function triggerAutoCalc(target) {
    if (!target) return;
    ["input", "change", "keyup"].forEach(function (evtName) {
      target.dispatchEvent(new Event(evtName, { bubbles: true }));
    });
    if (typeof window.PriceUpdation === "function") {
      window.PriceUpdation();
    }
  }
  

  
  
  function setWidthInputVals() {
    for(let i = 0; i < calc.length; i++){
      let calcName = (calc[i].dataset.calcname || "").replace(/\s+/g, "");
      if(calcName === "Width" || calcName === "width" || calcName === "Length"){
    calc[i].addEventListener("blur", function () {
     // console.log("widthInput" , widthInput);
          let valueChanged = false;
          if (parseInt(widthInput) < parseInt(minW.innerHTML.replace(/,/g, ""))) {
         
            this.value = parseInt(minW.innerHTML.replace(/,/g, ""));
            valueChanged = true;
          }
          if (parseInt(widthInput) > parseInt(maxW.innerHTML.replace(/,/g, ""))) {
            this.value = parseInt(maxW.innerHTML.replace(/,/g, ""));
            valueChanged = true;
          }
          if (this.value == "") {
            this.value = 200;
            valueChanged = true;
          }
          // 自動調整された場合、カートボタンのバリデーションチェックを実行
          if (valueChanged) {
            // 少し遅延させて、ツールチップの非表示処理が完了してから実行
            setTimeout(
              function () {
                triggerAutoCalc(this);
              }.bind(this),
              100
            );
          }
      });
      }
    }
  }

  function setHeightInputVals() {
    for(let i = 0; i < calc.length; i++){
      // calcnameの空白を除去して比較
      let calcName = (calc[i].dataset.calcname || "").replace(/\s+/g, "");

      if(calcName === "Height" || calcName === "diamater" || calcName === "length"){

        calc[i].addEventListener("blur", function () {
       // console.log("heightInput" , heightInput);
          let valueChanged = false;
          if (parseInt(heightInput) > parseInt(maxH.innerHTML.replace(/,/g, ""))) {
            this.value = parseInt(maxH.innerHTML.replace(/,/g, ""));
            valueChanged = true;
          }
          if (parseInt(heightInput) < parseInt(minH.innerHTML.replace(/,/g, ""))  ) {
            this.value = parseInt(minH.innerHTML.replace(/,/g, ""));
            valueChanged = true;
          }
          if (this.value == "") {
            
            this.value = 200;
            valueChanged = true;
          }
          // 自動調整された場合、カートボタンのバリデーションチェックを実行
          if (valueChanged) {
            // 少し遅延させて、ツールチップの非表示処理が完了してから実行
            setTimeout(
              function () {
                triggerAutoCalc(this);
              }.bind(this),
              100
            );
          }
      });
      }
    }
  }

  function getPriceInput() {
    const priceTicker = document.querySelectorAll("#priceTicker")[0];
    let w;
    let price;
    calc[1] &&
      calc[1].addEventListener("blur", function () {
        if (parseInt(widthInput) <= 300) {
          w1 = parseInt(widthInput) / 1000;
          // w1 = true
        }
        w = parseInt(widthInput) / 1000;
      });

    calc[1] &&
      calc[1].addEventListener("blur", function () {
        if (parseInt(heightInput) <= 300) {
          let h = parseInt(heightInput) / 1000;
          // let h = true
          let tally = h * w;
          if (tally <= 0.09) {
            // alert("its under 0.09")
          }
        }
      });
  }

  // 入力要素が DOM 上に現れたタイミングで一度だけ各種ハンドラを初期化する
  function initCalcHandlersOnce() {
    if (handlersInitialized) return;

    // 必要な要素が揃っていないページでは初期化しない
    if (!calc.length || !maxH || !minH || !minW || !maxW) return;

    handlersInitialized = true;

    getHeightInput();
    getWidthInput();
    // getQuantityInput();
    setHeightInputVals();
    setWidthInputVals();
    getPriceInput();
    setBorder();
  }

  // 必須入力がすべて埋まったときだけカートボタンを活性化する
  function setupCartButtonValidation() {
    if (cartButtonValidationInitialized) return;

    const form = document.querySelector(".ssw-product-form");
    const addCartBtn = document.querySelector("#add-crt-btn");

    if (!form || !addCartBtn) return;

    // 計算用入力（高さ・幅など）
    const calcInputs = form.querySelectorAll(".calc-prop");
    // セレクトボックス（分割数・取っ手・リベット）
    const optionSelects = form.querySelectorAll(
      '[data-element="CustomValue"] select, [data-element="Option1"] select, [data-element="Option2"] select'
    );

    if (!calcInputs.length && !optionSelects.length) return;

    cartButtonValidationInitialized = true;

    // 初期状態は非活性
    addCartBtn.disabled = true;

    function isFilled(el) {
      if (!el) return false;
      if (el.tagName === "SELECT") {
        // 「選択してください」などのプレースホルダーを除外（value が空 or -1 を想定）
        return el.value !== "" && el.value !== "-1";
      }
      if ("value" in el) {
        return String(el.value).trim() !== "";
      }
      return false;
    }

    function updateButtonState() {
      // 必須入力がすべて埋まっているか
      const allCalcFilled =
        !calcInputs.length ||
        Array.prototype.every.call(calcInputs, function (el) {
          return isFilled(el);
        });

      const allOptionsFilled =
        !optionSelects.length ||
        Array.prototype.every.call(optionSelects, function (el) {
          return isFilled(el);
        });

      // 幅・高さの範囲エラーがないか（最小値・最大値チェック）
      let hasSizeError = false;
      Array.prototype.forEach.call(calcInputs, function (el) {
        const val = String(el.value || "").trim();
        if (val === "") return;
        const num = parseInt(val, 10);
        if (Number.isNaN(num)) return;

        const calcName = el.dataset.calcname;
        if (calcName === "Height" || calcName === "diamater") {
          const min = parseInt(minH.innerHTML.replace(/,/g, ""), 10);
          const max = parseInt(maxH.innerHTML.replace(/,/g, ""), 10);
          if (num < min || num > max) {
            hasSizeError = true;
          }
        }
        if (
          calcName === "Width" ||
          calcName === "width" ||
          calcName === "Length"
        ) {
          const min = parseInt(minW.innerHTML.replace(/,/g, ""), 10);
          const max = parseInt(maxW.innerHTML.replace(/,/g, ""), 10);
          if (num < min || num > max) {
            hasSizeError = true;
          }
        }
      });

      const shouldEnable = allCalcFilled && allOptionsFilled && !hasSizeError;
      addCartBtn.disabled = !shouldEnable;
    }

    // 変更時に状態を再判定
    calcInputs.forEach(function (el) {
      el.addEventListener("input", updateButtonState);
      el.addEventListener("change", updateButtonState);
    });

    optionSelects.forEach(function (el) {
      el.addEventListener("change", updateButtonState);
      el.addEventListener("input", updateButtonState);
    });

    // 初期判定
    updateButtonState();
  }

  // 外部計算機アプリが完全に読み込まれたことを確認する関数
  function waitForCalculatorApp(callback, maxAttempts = 50, interval = 100) {
    let attempts = 0;
    
    function check() {
      attempts++;
      
      // 外部計算機アプリが読み込まれているか確認
      // .calc-prop 要素に onkeyup や onchange 属性が設定されているか確認
      const calcElements = document.querySelectorAll('.calc-prop');
      let appReady = false;
      
      if (calcElements.length > 0) {
        // 少なくとも1つの要素に onkeyup または onchange が設定されているか確認
        for (let i = 0; i < calcElements.length; i++) {
          if (calcElements[i].hasAttribute('onkeyup') || 
              calcElements[i].hasAttribute('onchange') ||
              typeof window.PriceUpdation === 'function') {
            appReady = true;
            break;
          }
        }
      }
      
      if (appReady || attempts >= maxAttempts) {
        callback();
      } else {
        setTimeout(check, interval);
      }
    }
    
    check();
  }

  // 外部計算機アプリの読み込みを待ってから初期化
  waitForCalculatorApp(function() {
    initCalcHandlersOnce();
    setupCartButtonValidation();
    
    // 後から .calc-prop が挿入される場合に備えて監視する
    if (!handlersInitialized) {
      const observer = new MutationObserver(function (mutations) {
        // .calc-prop 要素が追加されたかチェック
        let calcPropsAdded = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('calc-prop')) {
                calcPropsAdded = true;
              }
              if (node.querySelectorAll && node.querySelectorAll('.calc-prop').length > 0) {
                calcPropsAdded = true;
              }
            }
          });
        });
        
        // .calc-prop 要素が存在する場合、初期化を試みる
        const currentCalcElements = document.querySelectorAll('.calc-prop');
        if (calcPropsAdded || (currentCalcElements.length > 0 && !handlersInitialized)) {
          initCalcHandlersOnce();
          setupCartButtonValidation();
          if (handlersInitialized && cartButtonValidationInitialized) {
            observer.disconnect();
          }
        }
      });

      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    }
  });

  const cartInput = document.querySelector(".cart-input-count");
  const updateCart = document.querySelector(".cart-update-link");
  const contactErr = document.querySelector("#err-list");

  if (cartInput) {
    if (parseInt(cartInput.value) > parseInt(cartInput.max)) {
      cartInput.value = cartInput.max;
      updateCart.click();
    }
  }

  if (
    contactErr &&
    contactErr.innerHTML.includes("The <strong>email</strong> 無効です")
  ) {
    contactErr.innerHTML = "正しメールアドレスをご入力ください。";
  }

  // Custom filter search functionality
  const prodNumList = document.querySelectorAll(".p-num");
  const prodMakerList = document.querySelectorAll(".p-maker");
  const prodNameList = document.querySelectorAll(".p-name");
  const prodMaterialsList = document.querySelectorAll(".p-material");
  const prodEfficiencyList = document.querySelectorAll(".p-efficiency");
  const prodPressureList = document.querySelectorAll(".p-pressure");
  const prodThicknessList = document.querySelectorAll(".p-thickness");
  const noResults = document.querySelector(".noResults");
  const productList = document.querySelectorAll(".product-list");
  const prodCount = document.querySelector(".TopList_count");
  const searchBtn = document.querySelector(".TopSearch_btn");

  // Selected dropdown elements for filtering
  const prodNumMenu = document.querySelector("#product-number");
  const makerNameMenu = document.querySelector("#maker-name");
  const prodNameMenu = document.querySelector("#product-name");
  const prodMaterialMenu = document.querySelector("#material");
  const prodEfficiencyMenu = document.querySelector("#efficiency");
  const pressureLossMenu = document.querySelector("#pressure-loss");
  const thicknessMenu = document.querySelector("#thickness");
  const boxesMenu = document.querySelector("#boxes");

  // Event listeners
  prodNumMenu !== null && prodNumMenu.addEventListener('change', getProdNum);
  makerNameMenu !== null && makerNameMenu.addEventListener('change', getMakerName);
  prodNameMenu !== null && prodNameMenu.addEventListener('change', getProdName);
  prodMaterialMenu !== null && prodMaterialMenu.addEventListener('change', getMaterial);
  prodEfficiencyMenu !== null && prodEfficiencyMenu.addEventListener('change', getEfficiency);
  pressureLossMenu !== null && pressureLossMenu.addEventListener('change', getPressure);
  thicknessMenu !== null && thicknessMenu.addEventListener('change', getThickness);
  boxesMenu !== null && boxesMenu.addEventListener('change', getBoxes);

  let selectedPNum;
  let selectedMaker;
  let selectedProdName;
  let selectedMaterial;
  let selectedEfficiency;
  let selectedPressure;
  let selectedThickness;
  let selectedBoxes;
  let selectedTagName;

  // Functions to get the selected values from the drop down menus
  function getProdNum() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "品番") {
      selectedPNum = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedPNum = "";
      this.style.color = "";
    }
  }

  function getMakerName() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "メーカー名") {
      selectedMaker = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedMaker = "";
      this.style.color = "";
    }
  }

  function getProdName() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "商品名") {
      selectedProdName = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedProdName = "";
      this.style.color = "";
    }
  }

  function getMaterial() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "材質/使用繊維") {
      selectedMaterial = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedMaterial = "";
      this.style.color = "";
    }
  }

  function getEfficiency() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "捕集効率") {
      selectedEfficiency = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedEfficiency = "";
      this.style.color = "";
    }
  }

  function getPressure() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "圧力損失") {
      selectedPressure = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedPressure = "";
      this.style.color = "";
    }
  }

  function getThickness() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "厚み") {
      selectedThickness = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedThickness = "";
      this.style.color = "";
    }
  }

  function getBoxes() {
    let selected = this.options[this.selectedIndex].text;
    if(selected !== "アルミ枠") {
      selectedBoxes = selected;
      this.style.color = "#dd3f24";
    } else {
      selectedBoxes = "";
      this.style.color = "";
    }
  }

  // Function that sets the results of the selected menu items
  function getSearchResults(e) {
    e.preventDefault();

    if (noResults) {
      noResults.style.display = "none";
    }

    let pNumArr = [];
    let makerArr = [];
    let prodNameArr = [];
    let materialsArr = [];
    let efficiencyArr = [];
    let pressureLossArr = [];
    let thicknessArr = [];
    let boxesArr = [];

    // Loops to get selected items
    for(let i = 0; i < prodNumList.length; i++) {
      if(prodNumList[i].innerHTML.includes(selectedPNum)) {
        let pnumID = prodNumList[i].id.substring(prodNumList[i].id.indexOf(' ') + 1);
        pNumArr.push(pnumID);
      }
    }

    for(let i = 0; i < prodMakerList.length; i++) {
      if(prodMakerList[i].innerHTML.includes(selectedMaker)) {
        let makerID = prodMakerList[i].id.substring(prodMakerList[i].id.indexOf(' ') + 1);
        makerArr.push(makerID);
      }
    }

    for(let i = 0; i < prodNameList.length; i++) {
      if(prodNameList[i].innerHTML.includes(selectedProdName)) {
        let prodNameID = prodNameList[i].id.substring(prodNameList[i].id.indexOf(' ') + 1);
        prodNameArr.push(prodNameID);
      }
    }

    for(let i = 0; i < prodMaterialsList.length; i++) {
      if(prodMaterialsList[i].innerHTML.includes(selectedMaterial)) {
        let materialID = prodMaterialsList[i].id.substring(prodMaterialsList[i].id.indexOf(' ') + 1);
        materialsArr.push(materialID);
      }
    }

    for(let i = 0; i < prodEfficiencyList.length; i++) {
      if(prodEfficiencyList[i].innerHTML.includes(`(平均)${selectedEfficiency}`)) {
        let efficiencyID = prodEfficiencyList[i].id.substring(prodEfficiencyList[i].id.indexOf(' ') + 1);
        efficiencyArr.push(efficiencyID);
      }
    }

    for(let i = 0; i < prodPressureList.length; i++) {
      if(prodPressureList[i].innerHTML.includes(selectedPressure)) {
        let pressureID = prodPressureList[i].id.substring(prodPressureList[i].id.indexOf(' ') + 1);
        pressureLossArr.push(pressureID);
      }
    }

    for(let i = 0; i < prodThicknessList.length; i++) {
      if(prodThicknessList[i].innerHTML.includes(selectedThickness)) {
        let thicknessID = prodThicknessList[i].id.substring(prodThicknessList[i].id.indexOf(' ') + 1);
        thicknessArr.push(thicknessID);
      }
    }

    // Filter by aluminum frame (boxes)
    if(selectedBoxes) {
      productList.forEach((el) => {
        const productId = el.id;
        const hasAluminumFrame = el.getAttribute('data-has-aluminum-frame') === 'true';
        
        if(selectedBoxes === "あり" && hasAluminumFrame) {
          boxesArr.push(productId);
        } else if(selectedBoxes === "なし" && !hasAluminumFrame) {
          boxesArr.push(productId);
        }
      });
    }

    // Filter by tag name
    let tagArr = [];
    if(selectedTagName) {
      productList.forEach((el) => {
        const productId = el.id;
        const tags = el.getAttribute('data-product-tags');
        if(tags && tags.split(',').includes(selectedTagName)) {
          tagArr.push(productId);
        }
      });
    }

    // If the array of each selected item is not empty then add it to the options array
    let optionsArray = [];

    pNumArr.length > 0 && optionsArray.push(pNumArr);
    makerArr.length > 0 && optionsArray.push(makerArr);
    prodNameArr.length > 0 && optionsArray.push(prodNameArr);
    materialsArr.length > 0 && optionsArray.push(materialsArr);
    efficiencyArr.length > 0 && optionsArray.push(efficiencyArr);
    pressureLossArr.length > 0 && optionsArray.push(pressureLossArr);
    thicknessArr.length > 0 && optionsArray.push(thicknessArr);
    boxesArr.length > 0 && optionsArray.push(boxesArr);
    tagArr.length > 0 && optionsArray.push(tagArr);

    // Function checks all arrays for common ids. Returns common Ids
    if(optionsArray.length != 0) {
      const result = optionsArray.shift().filter(function(v) {
        return optionsArray.every(function(a) {
          return a.indexOf(v) !== -1;
        });
      });

      if(!result.length && noResults) {
        noResults.style.display = "block";
      }

      // Hide all list elements
      productList.forEach((el) => el.style.display = "none");

      // Loop through the results array check if the ids match the hidden element and show that element
      if (prodCount) {
        prodCount.innerHTML = `全${result.length}件`;
      }

      for(let i = 0; i < result.length; i++) {
        productList.forEach((el) => {
          if(el.id === result[i]) {
            el.style.display = "table-row";
          }
        });
      }

      const element = document.getElementById('shopify-section-product-select');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      if (prodCount) {
        prodCount.innerHTML = `全${productList.length}件`;
      }
      productList.forEach((el) => {
        el.style.display = "table-row";
      });
    }
  }

  // Add event listener to search button
  if (searchBtn) {
    searchBtn.addEventListener('click', (e) => {
      getSearchResults(e);
    });
  }
});
